import { useEffect } from "react";
import Moment from "react-moment";
import { Card, CardBody, Table } from "reactstrap";

import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { setGetMethod } from "reducers/dto.slice";
import { setDemoOrders, setOrder } from "reducers/order.slice";
import { getOrders } from "services/order.service";

import { DEMO_EMAIL } from "appConstants";
import OrderEntry from "components/OrderEntry";
import DataFilters from "components/shared/DataFilters";
import Paging from "components/shared/Paging";
import StatusProgressBar from "./shared/StatusProgressBar";
import TableEmptyState from "./shared/TableEmptyState";

const Orders = () => {

    const customer = useAppSelector(x => x.customers.selectedCustomer);
    const orders = useAppSelector(x => x.orders.ordersDto.items);

    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);
    const isLoading = useAppSelector(x => x.invoices.loading || x.orders.loading || x.cases.loading || x.returns.loading || x.creditMemos.loading);
    const ordersLoading = useAppSelector(x => x.orders.loading);
    const ordersError = useAppSelector(x => x.orders.error);

    const selectedOrder = useAppSelector(x => x.orders.selectedOrder);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (customer?.email === DEMO_EMAIL) {
            dispatch(setDemoOrders());
        } else {
            dispatch(setGetMethod(getOrders));
            dispatch(getOrders(searchDto));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, customer]);

    const onOrderClick = (id?: number) => {
        dispatch(setOrder(id || 0));
    };

    return (
        <>
            {selectedOrder ?
                <OrderEntry />
                :
                <Card className="shadow">
                    <DataFilters />
                    <CardBody>
                        <div>
                            <Table bordered striped hover={!isLoading} responsive className="bcd-data-table">
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Purchase Order</th>
                                        <th>Sales Order</th>
                                        <th>Shipper</th>
                                        <th className="text-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {orders.length > 0
                                        ? orders.map(o => {
                                            return (<tr key={o.transactionId}
                                                role={isLoading ? undefined : "button"}
                                                tabIndex={isLoading ? undefined : 0}
                                                aria-label={`View order ${o.salesOrder}`}
                                                onClick={() => !isLoading && onOrderClick(o.transactionId)}
                                                onKeyDown={(e) => { if (!isLoading && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); onOrderClick(o.transactionId); } }}
                                            >
                                                <td width="10%">
                                                    <Moment format="MM/DD/YYYY">
                                                        {o.transactionDate}
                                                    </Moment>
                                                </td>
                                                <td width="15%">{o.purchaseOrder}</td>
                                                <td width="10%">{o.salesOrder}</td>
                                                <td width="20%">{o.shipper}</td>
                                                <td className="p-0"> <StatusProgressBar status={o.status?.toLowerCase()} /> </td>
                                            </tr>);
                                        })
                                        : <TableEmptyState colSpan={5} isLoading={ordersLoading} error={ordersError} entityName="Orders" />}
                                </tbody>
                            </Table>
                        </div>
                        <Paging />
                    </CardBody>
                </Card>}
        </>
    );
}

export default Orders;